import React from "react";

import { classNames } from "@greeter/util";

import css from "./MessageBox.module.scss";

export type MessageBoxProps = React.HTMLProps<HTMLTextAreaElement>;

export const MessageBox: React.FC<MessageBoxProps> = ({
  className,
  ...props
}) => {
  return (
    <textarea
      {...props}
      lang={"DK"}
      spellCheck={false}
      {...classNames(css.MessageBox, className)}
    />
  );
};
